// import logo from './logo.svg';
import './App.css';
import Navbar from "./Components/Navbar"
function App() {
  return (
   <>
   {/* <h1>vhvhvhj</h1> */}
   < Navbar />
  </>
  );
}

export default App;
